/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import DomainModel from 'cio/models/domain';
import IdentityModel from 'cio/models/identity';

interface SendingDomainsDomainDetailsArgs {
  domain: DomainModel;
  identities: IdentityModel[];
  onUpdateIdentity: () => unknown;
  hasCustomMailServers: boolean;
}

export default class SendingDomainsDomainDetails extends Component<SendingDomainsDomainDetailsArgs> {}
